import React, { useState, useMemo, useCallback, isValidElement } from 'react';
import useResponsiveValue from '../../../hooks/useResponsiveValue.js';
import warn from '../../../utils/warn.js';
import { PaginationList } from '../PaginationList.js';
import '../../../hooks/useBreakpointIndex.js';
import '@emotion/react';
import '../../../_rollupPluginBabelHelpers-mO86zOh3.js';
import '@indeed/ifl-css';
import '../PaginationArrowButton.js';
import '@indeed/ifl-icons';
import './usePageLinkProps.js';
import './usePaginationContext.js';
import '../PaginationContext.js';
import '../../LinkProvider/LinkProvider.js';
import '../defaultStrings.js';
import '../../ButtonLink/ButtonLink.js';
import '../../Button/Button.js';
import '../../../utils/transition.js';
import '../../../utils/styled.js';
import '../../../constants/index.js';
import '../../../utils/createResponsive.js';
import '../../../utils/transparentize.js';
import '../../Button/context.js';
import '../../Spinner/Spinner.js';
import '@indeed/ihl-use-id';
import '../../IconWrapper/IconWrapper.js';
import '../PaginationEllipsis.js';
import '../PaginationPage.js';
import './usePaginationList.js';
import '../util.js';

const usePagination = _ref => {
  let {
    children,
    defaultPage,
    itemsPerPage,
    onPageChange,
    page,
    totalItems,
    orientationProp,
    alignmentProp
  } = _ref;
  const orientation = useResponsiveValue(orientationProp);
  const alignment = useResponsiveValue(alignmentProp);
  const [uncontrolledPage, setUncontrolledPage] = useState(defaultPage);
  const totalPages = useMemo(() => Math.ceil(totalItems / itemsPerPage), [totalItems, itemsPerPage]);
  const activePage = useMemo(() => Math.min((page && !isNaN(page) && page > 0 ? page : null) ?? uncontrolledPage ?? 1, totalPages), [page, totalPages, uncontrolledPage]);
  const handlePageChange = useCallback(pageNumber => {
    if (page == null) {
      setUncontrolledPage(pageNumber);
    }
    onPageChange?.(pageNumber);
  }, [page, onPageChange]);
  const handlePrevClick = useCallback(() => {
    if (activePage !== undefined && activePage > 1) {
      handlePageChange?.(activePage - 1);
    }
  }, [activePage, handlePageChange]);
  const handleNextClick = useCallback(() => {
    if (activePage !== undefined && totalPages !== undefined && activePage < totalPages) {
      handlePageChange?.(activePage + 1);
    }
  }, [activePage, totalPages, handlePageChange]);
  const sortedChildren = useMemo(() => {
    const childrenArray = React.Children.toArray(children);
    return childrenArray.reduce((acc, cur) => {
      if (/*#__PURE__*/isValidElement(cur)) {
        return !acc.paginationList && cur.type === PaginationList ? {
          ...acc,
          paginationList: cur
        } : {
          ...acc,
          rest: [...acc.rest, cur]
        };
      }
      warn("Child not rendered because it is not a valid React element");
      return acc;
    }, {
      paginationList: null,
      rest: []
    });
  }, [children]);
  const hasPaginationList = !!sortedChildren.paginationList;
  return {
    activePage,
    handlePageChange,
    handlePrevClick,
    handleNextClick,
    hasPaginationList,
    sortedChildren,
    totalPages,
    orientation,
    alignment
  };
};

export { usePagination };
